import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";
import { OrderCollectionModel } from "@insite/client-framework/Types/ApiModels";
import QuotesListState from "../Data/ADIQuotesListState";

const initialState: QuotesListState = {
    isLoading: false,
    parameter: {
        refrencenumber: "",
        ordersearchtype: "ALL",
        status: "QU",
        quotetype: "-1",
        fromDate: "",
        toDate: "",
        sort: "CreationDate DESC",
        customerSequence: "-1",
        currentPage: 1,
        pageSize: 12,
        dateType: "30days",
        selectedpage: "1",
        isSearch: "",
        dateRange: "30days",
        dateRangeDesc: "Last 30 days",
        statusDesc: "All",
        quotetypeDesc: "All",
        page: "1",
        properties: "{'quotetype':'-1','status':'QU'}",
    },
    quotesList: {
        orders: null,
        uri: "",
        properties: {},
        pagination: null,
        showErpOrderNumber: false,
    },
    allcustomersuffix: "-1",
};

const reducer = {
    "Custom/DispatchLoadQuotesList": (draft: Draft<QuotesListState>, action: { result: OrderCollectionModel }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteLoadParameter": (draft: Draft<QuotesListState>, action: { parameter: any }) => {
        draft.parameter = action.parameter;
    },
    "Custom/DispatchCompleteLoadQuotesList": (
        draft: Draft<QuotesListState>,
        action: { quotesList: OrderCollectionModel; id: string; errorMessage?: string },
    ) => {
        draft.isLoading = false;

        draft.quotesList = action.quotesList;
    },
    "Custom/DispatchUpdateResetQuotePagination": () => {
        return initialState;
    },
    "Custom/UpdateAllCustomerSuffix": (draft: Draft<QuotesListState>, action: { result: string }) => {
        draft.allcustomersuffix = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
